module.exports = __webpack_public_path__ + "static/media/LookNorth.svg";